// SaveCambioService.tsx

import { ActualizarCambioRequest, CreateCambiosForm, CrearCambioRequest, CambioResponse } from "../../types";
import { Areascontrolcambios } from "../../../areascontrolcambios/types";
import { useFetchGetNotificaciones, useFetchGetTiposAccion, useFetchPostCambioService, useFetchPutCambioService, useResponsablesConNombre} from '@/shared/actions'
import { useFieldArray, useForm } from 'react-hook-form';
import { ServicioAfectadoRow } from "../ServicioAfectado/ServicioAfectadoRow";
import {cambioServiceSchema} from '../../utils/cambio-service.schema'
import { useWatch, Resolver } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { SectionCard, SectionHeader, RecordCard } from "../../hooks";
import { ROUTER_PATHS } from '@/shared';

import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  CustomTextField,
  FormTabsOnly,
  CreateOrCancelButtons,
  CustomAutocomplete,
  CustomAutocompleteMultipleSelect,
  LoaderComponent
} from '@/shared/components/ui';

import { CustomAutocompleteDynamicSearch } from '@/shared/components/ui';
import { useFetchUsuariosSistemaSinModulos } from '@/shared/actions/erp/administration/usuarios';
import { useState } from 'react';

import { useFetchGetAreascontrolcambios, useAprobadoresPorAreas, useFetchGetTiposRiesgo  } from "@/shared/actions";
import { useTabsFormOnly, a11yProps } from "@/shared";
import { Grid, Button, Typography, Divider, Tab, Box, Container, Stack } from "@mui/material";
import { toast } from "react-toastify";
import { CardPersonalizado } from "@/shared/components/ui/Alerts";


  const generarTiempoRelativo = (horasDuracion: number) => {
   if (!horasDuracion) return [];

  const totalMinutos = horasDuracion * 60;

  const opciones = [];

  for (let minutos = 0; minutos <= totalMinutos; minutos += 10) {
    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;

    opciones.push({
      id: `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`,
      nombre: `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`,
    });
  }

  return opciones;
};

const TIPO_CAMBIO_OPTIONS = [
  { id: 'ACTUALIZACION', nombre: 'Actualización' },
  { id: 'MANTENIMIENTO_PREVENTIVO', nombre: 'Mantenimiento Preventivo' },
  { id: 'MANTENIMIENTO_CORRECTIVO', nombre: 'Mantenimiento Correctivo' },
  { id: 'IMPLEMENTACION', nombre: 'Implementación' },
  { id: 'CONFIGURACION', nombre: 'Configuración' },
];

const CLIENTE_AFECTADO_OPTIONS = [
  { id: "SERVIDORES", nombre: "Servidores" },
  { id: "OLT", nombre: "OLT" },
];




const PRIORIDAD_OPTIONS = [
  { id: 'ALTA', nombre: 'ALTA' },
  { id: 'MEDIA', nombre: 'MEDIA' },
  { id: 'BAJA', nombre: 'BAJA' },
];

const IMPACTO_OPTIONS = [
  { id: 'ALTO', nombre: 'ALTO' },
  { id: 'MEDIO', nombre: 'MEDIO' },
  { id: 'BAJO', nombre: 'BAJO' },
];

const DURACION_OPTIONS = Array.from({ length: 24 }, (_, i) => {
  const hora = i + 1;
  return {
    id: hora, // El valor numérico que va al back
    nombre: hora === 1 ? '1 hora' : `${hora} horas` // Lo que ve el usuario
  };
});

const RIESGO_OPTIONS = [
  { id: 'ALTO', nombre: 'ALTO' },
  { id: 'MEDIO', nombre: 'MEDIO' },
  { id: 'BAJO', nombre: 'BAJO' },
];


const PROBABILIDAD_OPTIONS = [
  { id: 'Baja', nombre: 'Baja' },
  { id: 'Media', nombre: 'Media' },
  { id: 'Alta', nombre: 'Alta' },
];

type SaveCambioServiceProps = {
  titulo: string
  data?: CambioResponse | null
  idCambio? : string
}

// export type SaveFormData = CreateCambios;
export type SaveFormData = CrearCambioRequest;

export default function SaveCambioService({
  titulo,
  data,
  idCambio,
}: SaveCambioServiceProps) {




  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
    const returnUrl =
      searchParams.get("origen") === "mis"
        ? ROUTER_PATHS.control_cambios.misCambiosNav
        : ROUTER_PATHS.control_cambios.cambioServicenav;
        ///
        const [writtenSolicitante, setWrittenSolicitante] = useState("");
  const { data: usuariosRes, isLoading: loadingUsuarios } = useFetchUsuariosSistemaSinModulos({
    enabled: true,
    params: { page: 1, page_size: 20, razon_social: writtenSolicitante },
  });
  const solicitantes = (usuariosRes?.data?.data ?? [])
    .filter((u) => u.is_active)                       // 👈 solo activos
    .map((u) => ({
      id: u.id as number,
      razon_social: u.profile?.razon_social ?? u.username,
  }));

      ///

  const createMutation = useFetchPostCambioService({
  
    returnUrl,
    navigate,
  });
  //update
  const updateMutation = useFetchPutCambioService({
    // returnUrl: ROUTER_PATHS.control_cambios.cambioServicenav,
    returnUrl,
    navigate,
  });
  ///responsables y notificaciones
  // const { data: responsablesResp, isLoading: loadingResp } = useFetchGetResponsables();
  const { data: notificacionesResp, isLoading: loadingNoti } = useFetchGetNotificaciones();

  //notificaciones antes:
  // const notificacionesActivas = useMemo(
  //   () => (notificacionesResp?.data || []).filter((n: any) => n.estado),
  //   [notificacionesResp]
  // );
  //Notificaciones despues: 
    const notificacionesActivas = useMemo(
  () =>
    (notificacionesResp?.data || [])
      .filter((n: any) => n.estado)
      .map((n: any) => ({
        ...n,
        nombre: n.correo ? `${n.nombre} (${n.correo})` : n.nombre,
      })),
  [notificacionesResp]
);


  const { responsables: responsablesConNombre } =
  useResponsablesConNombre();
console.log("MAIN DE RESPONSABLESs", responsablesConNombre)
const form = useForm<CreateCambiosForm>({
  resolver: yupResolver(cambioServiceSchema) as unknown as Resolver<CreateCambiosForm>,
  mode: "onChange",
  defaultValues: data
    ? {
        titulo: data.titulo ?? "",
        descripcion: data.descripcion ?? "",
        prioridad: data.prioridad ?? "",
        impacto: data.impacto ?? "",
        riesgo: data.riesgo ?? "",
        tipoCambio: data.tipoCambio ?? "",
        fechaProgramada: data.fechaProgramada ?? "",
        horaProgramada: (data.horaProgramada ?? "").slice(0, 5), // "HH:mm:ss" -> "HH:mm"
        duracion: data.duracion ?? "",
        solicitante: data.solicitante ?? "",
        areasAfectas: data.areasAfectas ?? [],
        aprobadores: data.aprobadores?.length
          ? data.aprobadores.map((a) => ({ areaId: a.areaId, aprobadorId: a.usuarioId }))
          : [{ areaId: '', aprobadorId: '' }], // (aprobadores se hace en paso aparte)
        responsableIds: data.responsableIds ?? [],
        notificacionIds: data.notificacionIds ?? [],
        serviciosAfectados:
          data.serviciosAfectados?.length
            ? data.serviciosAfectados.map((s) => ({
                ...s,
                tiempoAfectacion: (s.tiempoAfectacion ?? "").slice(0, 5), // "HH:mm:ss" -> "HH:mm"
              }))
            : [{ tiempoAfectacion: "", clienteAfectado: "", servicio: "" }],

        planAccion:
          data.planAccion?.length
            ? data.planAccion
            : [{ accion: "", responsable: "", fecha: "", observacion: "" }],

        riesgos:
          data.riesgos?.length
            ? data.riesgos
            : [{
                descripcion: "",
                impacto: "",
                probabilidad: "",
                tipoRiesgo: "",
                accionContingencia: "",
              }],

        rollbackActividades:
          data.rollbackActividades?.length
            ? data.rollbackActividades
            : [{ actividad: "", duracion: "", responsable: "" }],
      }
    : {
        titulo: "",
        descripcion: "",
        prioridad: "",
        impacto: "",
        riesgo: "",
        tipoCambio: "",
        fechaProgramada: "",
        horaProgramada: "",
        duracion: "",
        solicitante: "",

        areasAfectas: [],

        serviciosAfectados: [
          { tiempoAfectacion: "", clienteAfectado: "", servicio: "" },
        ],

        planAccion: [
          { accion: "", responsable: "", fecha: "", observacion: "" },
        ],

        riesgos: [
          {
            descripcion: "",
            impacto: "",
            probabilidad: "",
            tipoRiesgo: "",
            accionContingencia: "",
          },
        ],

        rollbackActividades: [
          { actividad: "", duracion: "", responsable: "" },
        ],
        aprobadores: [{ areaId: '', aprobadorId: '' }],
        responsableIds: [],
        notificacionIds: [],
      },
});

 const {
  control,
  watch,
  handleSubmit,
  formState: { errors },
} = form;

// const areasSeleccionadas = useWatch({
//   control,
//   name: 'areasAfectas',
// }) || [];
console.log("FORM GET VALUES",form.getValues("planAccion"));
const horaProgramada = watch('horaProgramada');
const duracionId = watch("duracion");
// const duracionHoras = Number(duracionId || 0);
 const tiemposAfectacion = generarTiempoRelativo(Number(watch("duracion")))

let minTime = "";
let maxTime = "";
console.log(minTime, maxTime);
if (horaProgramada) {
  // El mínimo siempre será la hora programada
  minTime = horaProgramada;
  if (duracionId) {
    // Buscamos cuántas horas representa el ID seleccionado (asumiendo que el ID es el número de horas)
    // Si tu ID no es el número directo, mapealo con tu array DURACION_OPTIONS
    const horasAsumidas = Number(duracionId); 

    // Separamos horas y minutos de la hora programada
    const [horas, minutos] = horaProgramada.split(":").map(Number);

    // Creamos un objeto Date ficticio para sumar el tiempo fácilmente
    const fechaFicticia = new Date();
    fechaFicticia.setHours(horas, minutos, 0, 0);
    
    // Sumamos las horas de duración
    fechaFicticia.setHours(fechaFicticia.getHours() + horasAsumidas);

    // Formateamos de vuelta a "HH:MM" asegurando los dos dígitos
    const maxHoras = String(fechaFicticia.getHours()).padStart(2, "0");
    const maxMinutos = String(fechaFicticia.getMinutes()).padStart(2, "0");
    
    maxTime = `${maxHoras}:${maxMinutos}`;
  }

}
///TIPOACIONES
const {data:tipoaciones} = useFetchGetTiposAccion({
  estado: true,
})
//areas
const {data:areas, isLoading} = useFetchGetAreascontrolcambios();
const areasActivas = (areas?.data || []).filter((a) => a.activo);
const aprobadoresField = useFieldArray({ control, name: 'aprobadores' });
const aprobadoresRows = useWatch({ control, name: 'aprobadores' }) || [];
const areaIdsAprobadores = [...new Set(aprobadoresRows.map(r => r?.areaId).filter(Boolean))];
const { aprobadores, isLoading: loadingAprobadores } =
  useAprobadoresPorAreas(areaIdsAprobadores);


const areasDefault = useMemo(
  () => (areas?.data ?? []).filter((a) =>
    (data?.areasAfectas ?? []).includes(a.areaId ?? "") 
  ),
  [areas, data]
);
const notisDefault = useMemo(
  () =>
    (notificacionesActivas ?? []).filter((n: any) =>
      (data?.notificacionIds ?? []).includes(n.notificacionId)
    ),
  [notificacionesActivas, data]
);

////
///
const { data: tiposRiesgoResp } = useFetchGetTiposRiesgo({ page: 0, size: 1000, estado: true } as any);
   const tiposRiesgoOptions = useMemo(
     () => (tiposRiesgoResp?.data ?? []).filter((t) => t.estado).map((t) => ({ id: t.nombre, nombre: t.nombre })),
     [tiposRiesgoResp]
   );
console.log("areasAfectas del back:", data?.areasAfectas);
console.log("areasDefault:", areasDefault);
console.log("APRBOADORES", aprobadores)  
const onSave = (formData: CreateCambiosForm) => {
   const aprobadoresPares = (formData.aprobadores || [])
     .filter(a => a.areaId && a.aprobadorId)
     .map(a => ({ areaId: a.areaId, aprobadorId: Number(a.aprobadorId) }));
   const aprobadoresIds = aprobadoresPares.map(p => p.aprobadorId);

  const responsableIds = [
    ...new Set(
      [
        ...(formData.planAccion || []).map((p: any) => p.responsable),
        ...(formData.rollbackActividades || []).map((r: any) => r.responsable),
      ].filter(Boolean)
    ),
  ];

  const { aprobadores, ...resto } = formData; // saca el arreglo del form
 const payload: CrearCambioRequest = {
    ...resto,
    aprobadores: aprobadoresPares, // 👈 pares (los que respeta el back)
    aprobadoresIds,
    responsableIds,
    notificacionIds: formData.notificacionIds ?? [],
  };
  
  console.log("FORM DATA =>", formData);     // 👈 todo lo que tiene el form
  console.log("PAYLOAD A ENVIAR =>", payload);

  if (data && idCambio) {
    const updateData: ActualizarCambioRequest = {
      ...payload,
      estado: (data as any).estado || 'PENDIENTE',
    };
    updateMutation.mutate({ id: idCambio, data: updateData });
  } else {
    createMutation.mutate(payload);
  }
};


const serviciosField = useFieldArray({ control, name: 'serviciosAfectados' });
const planField = useFieldArray({ control, name: 'planAccion' });
const riesgosField = useFieldArray({ control, name: 'riesgos' });
const rollbackField = useFieldArray({ control, name: 'rollbackActividades' });


//TABS
const { valueTab, handleMethodChange } = useTabsFormOnly({ initialTabValue: 1 });
const isSaving = createMutation.isPending || updateMutation.isPending;

const tabHasError = useMemo(() => {
  const fieldMap: Record<number, string[]> = {
    1: ['titulo', 'descripcion', 'prioridad', 'impacto', 'riesgo', 'tipoCambio', 'fechaProgramada', 'horaProgramada', 'duracion', 'areasAfectas', 'notificacionIds'],
    2: ['serviciosAfectados'],
    3: ['planAccion', 'rollbackActividades'],
    4: ['riesgos'],
    5: ['aprobadores'],
  };

  return (tab: number) =>
    fieldMap[tab]?.some((field) => field in errors) ?? false;
}, [errors]);

const mensaje = " Antes de guardar la información en el control de cambios, complete todos los campos de todas las pestañas del formulario.";
return (
  
  <Box component="main" sx={{ flexGrow: 1 }}>
    {isSaving && <LoaderComponent />}
    <CardPersonalizado
                        alertTitle="Informacion del control de cambios "
                        alertMessage={
                          mensaje
                        }
                        bgColorAlert="GRAY"
                        alertColor="error"
                      />
    <Container maxWidth="xl" sx={{marginTop: 2}}>
      <Stack spacing={2}>
        <Typography variant="h4">{titulo}</Typography>

        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="General"    value={1} {...a11yProps(1)} sx={tabHasError(1) ? {color: 'error.main'} : undefined} />
          <Tab label="Alcance"    value={2} {...a11yProps(2)} sx={tabHasError(2) ? {color: 'error.main', marginLeft: 3} : undefined} />
          <Tab label="Ejecución"  value={3} {...a11yProps(3)} sx={tabHasError(3) ? {color: 'error.main', marginLeft: 3} : undefined} />
          <Tab label="Riesgos"    value={4} {...a11yProps(4)} sx={tabHasError(4) ? {color: 'error.main', marginLeft: 3} : undefined} />
          <Tab label="Aprobación" value={5} {...a11yProps(5)} sx={tabHasError(5) ? {color: 'error.main', marginLeft: 3} : undefined} />
        </FormTabsOnly>

    {/* ── Tab 1: General ── */}
     {/* ── Tab 1: General ── */}
    <div role="tabpanel" style={{ display: valueTab === 1 ? undefined : 'none', width: '100%' }}>
      <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
              <SectionCard>
                  <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 500,
                        mb: 1,
                        textTransform: "uppercase"
                      }}
                    >
                      DATOS GENERALES
                  </Typography>
                  <Divider sx={{mb: 1}} />  
             
                 <Grid
                  container
                  spacing={2}
                  mt={2}
                  sx={{ mb: 2 }}
                >

                    {/* FILA 1 */}
                    {/* Título */}
                    <Grid item xs={12} md={12} >
                      <CustomTextField
                        label="Título"
                        name="titulo"
                        control={control}
                        error={errors.titulo}
                        helperText={errors.titulo?.message}
                      />
                    </Grid>
              
                    {/* Descripción */}
                    <Grid item xs={12} md={12}>
                      <CustomTextField
                        label="Descripción"
                        name="descripcion"
                        control={control}
                        error={errors.descripcion}
                        helperText={errors.descripcion?.message}
                      />
                    </Grid>
              
                    {/* Prioridad */}
                    <Grid item xs={12} md={4}>
                      <CustomAutocomplete
                        name="prioridad"
                        label="Prioridad"
                        options={PRIORIDAD_OPTIONS}
                        valueKey="nombre"
                        actualValueKey="id"
                        isLoadingData={false}
                        error={errors.prioridad}
                        helperText={errors.prioridad?.message}
                        defaultValue=""
                        control={control}
                      />
                    </Grid>
              
                    {/* Impacto */}
                    <Grid item xs={12} md={4}>
                      <CustomAutocomplete
                        name="impacto"
                        label="Impacto"
                        options={IMPACTO_OPTIONS}
                        valueKey="nombre"
                        actualValueKey="id"
                        isLoadingData={false}
                        error={errors.impacto}
                        helperText={errors.impacto?.message}
                        defaultValue=""
                        control={control}
                      />
                    </Grid>
              
                    {/* Riesgo */}
                    <Grid item xs={12} md={4}>
                      <CustomAutocomplete
                        name="riesgo"
                        label="Riesgo"
                        options={RIESGO_OPTIONS}
                        valueKey="nombre"
                        actualValueKey="id"
                        isLoadingData={false}
                        error={errors.riesgo}
                        helperText={errors.riesgo?.message}
                        defaultValue=""
                        control={control}
                      />
                    </Grid>
              
                    {/* Tipo de Cambio */}
                    <Grid item xs={12} md={6}>
                      <CustomAutocomplete
                        name="tipoCambio"
                        label="Tipo de Cambio"
                        options={TIPO_CAMBIO_OPTIONS}
                        defaultValue={""}
                        valueKey="nombre"
                        actualValueKey="id"
                        isLoadingData={false}
                        error={errors.tipoCambio}
                        helperText={errors.tipoCambio?.message}
                        control={control}
                      />
                    </Grid>
              
                    {/* Áreas Afectadas */}
                    <Grid item xs={12} md={6}>
                      <CustomAutocompleteMultipleSelect<Areascontrolcambios>
                        key={`areas-${areas?.data?.length ?? 0}`} 
                        defaultValue={areasDefault}  
                        label="Áreas Afectadas"
                        name="areasAfectas"
                        options={areas?.data || []}
                        valueKey="nombre"
                        actualValueKey="areaId"
                        specificKey={"areaId"}
                        useSpecificKey={true}
                        isLoadingData={isLoading}
                        control={form.control}
                        error={!!errors.areasAfectas}
                        helperText={errors.areasAfectas?.message}
                        textFieldKey="areas"
                      />
                    </Grid>
              
                    {/* Fecha Programada */}
                    <Grid item xs={12} md={4}  sx={{marginTop: 2 }}>
                      <CustomTextField 
                        label="Fecha Programada"
                        name="fechaProgramada"
                        type="date"
                        control={control}
                        shrink
                        error={errors.fechaProgramada}
                        helperText={errors.fechaProgramada?.message}
                      />
                    </Grid>
              
                    {/* Hora Programada */}
                    <Grid item xs={12} md={4} sx={{marginTop: 2 }}>
                      <CustomTextField
                        label="Hora Programada"
                        name="horaProgramada"
                        type="time"
                        control={control}
                        shrink
                        error={errors.horaProgramada}
                        helperText={errors.horaProgramada?.message}
                      />
                    </Grid>

                    {/* Duración */} 
                    <Grid item xs={12} md={4}  sx={{marginTop: 2 }}>
                      <CustomAutocomplete
                        name="duracion"
                        label="Duración"
                        options={DURACION_OPTIONS}
                        valueKey="nombre"       // Lo que se muestra: "1 hora", "2 horas"...
                        actualValueKey="id"     // Lo que se guarda: 1, 2, 3...
                        isLoadingData={false}
                        error={errors.duracion}
                        helperText={errors.duracion?.message}
                        defaultValue=""
                        control={control}
                      />
                    </Grid>

                  <Grid item xs={12} md={6}>
                    <CustomAutocompleteMultipleSelect<any>
                      key={`notis-${notificacionesActivas.length}`}
                      defaultValue={notisDefault}
                      label="Notificaciones"
                      name="notificacionIds"
                      // options={notificacionesResp?.data || []}
                      options={notificacionesActivas}
                      valueKey="nombre"


                      actualValueKey="notificacionId"
                      specificKey={"notificacionId"}
                      useSpecificKey={true}
                      isLoadingData={loadingNoti}
                      control={control}
                      error={!!errors.notificacionIds}
                      helperText={errors.notificacionIds?.message}
                      textFieldKey="notificaciones"
                    />
                  </Grid>
                   <Grid item xs={12} md={6}>
                    <CustomAutocompleteDynamicSearch<{ id: number; razon_social: string }>
                      label="Solicitante"
                      name="solicitante"
                      control={control}
                      optionsFetched={solicitantes}
                      valueKey="razon_social"
                      actualValueKey="razon_social"        // 👈 guarda el nombre, no el id
                      isLoadingData={loadingUsuarios}
                      defaultValue={form.getValues().solicitante ?? ""}
                      setWrittenText={setWrittenSolicitante}
                      optionLabelForEdit={data?.solicitante ?? ""}  // alimenta la búsqueda en edición
                      error={errors.solicitante}
                      helperText={errors.solicitante?.message ?? ""}
                    />
                  </Grid>
                </Grid>
              </SectionCard>
            </Grid>      

      </Grid>
    </div>

    {/* ── Tab 2: Alcance ── */}
    <div role="tabpanel" style={{ display: valueTab === 2 ? undefined : 'none', width: '100%' }}>
      <Grid container spacing={2} mt={2}>
    {/* ══════════════════════════════════════════
        SERVICIOS AFECTADOS
    ══════════════════════════════════════════ */}
      <Grid item xs={12}>
        <SectionCard>
            <SectionHeader
              title="Servicios Afectados"
              count={serviciosField.fields.length}
            />
            <Divider sx={{mb: 2}} />
            {serviciosField.fields.map((field, index) => (
              <RecordCard
                key={field.id}
                title={`Servicio #${index + 1}`}
                disableDelete={serviciosField.fields.length === 1}
                onDelete={() => serviciosField.remove(index)}
                >

                <Grid
                  container
                  spacing={2}
                  key={field.id}
                  mt={2}
                  sx={{ mb: 2 }}
                >
                  <Grid item xs={12} md={4}>
                    <CustomAutocomplete
                        label="Tiempo de Afectación"
                        name={`serviciosAfectados.${index}.tiempoAfectacion`}
                        options = {tiemposAfectacion}
                        valueKey="nombre"
                        isLoadingData
                        actualValueKey="id"
                        defaultValue=""
                        control={control}
                        error={errors.serviciosAfectados?.[index]?.tiempoAfectacion}
                        helperText={
                          errors.serviciosAfectados?.[index]?.tiempoAfectacion?.message ?? ""
                        }
                      />

                  </Grid>

                  <Grid item xs={12} md={4}>
                    <CustomAutocomplete
                      label="Cliente"
                      name={`serviciosAfectados.${index}.clienteAfectado`}
                      options={CLIENTE_AFECTADO_OPTIONS}
                      valueKey="nombre"
                      actualValueKey="id"
                      defaultValue=""
                      isLoadingData={false}
                      control={control}
                      error={errors.serviciosAfectados?.[index]?.clienteAfectado}
                      helperText={
                        errors.serviciosAfectados?.[index]?.clienteAfectado?.message ?? ''
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {/* <CustomAutocomplete
                      label="Servicio"
                      name={`serviciosAfectados.${index}.servicio`}
                      options={SERVICIO_OPTIONS}
                      valueKey="nombre"
                      actualValueKey="id"
                      defaultValue=""
                      isLoadingData={false}
                      control={control}
                      error={errors.serviciosAfectados?.[index]?.servicio}
                      helperText={
                        errors.serviciosAfectados?.[index]?.servicio?.message ?? ''
                      } 
                    />*/}
                    <ServicioAfectadoRow
                        index={index}
                        control={control}
                        errors={errors}
                        setValue={form.setValue}
                      />
                  </Grid>

                  {/* <Grid item xs={12} md={3} display="flex">
                    <Button
                      fullWidth
                      color="error"
                      variant="contained"
                      disabled={serviciosField.fields.length === 1}
                      onClick={() => serviciosField.remove(index)}
                    >
                      Eliminar
                    </Button>
                  </Grid> */}
                </Grid>
              </RecordCard>

            ))}

          
            <AddRowButton
              label="+ Agregar servicio"
              onClick={() =>
                serviciosField.append({
                  tiempoAfectacion: "",
                  clienteAfectado: "",
                  servicio: "",
                })
              }
            />
          </SectionCard>

        </Grid>
      </Grid>
    </div>

        {/* ── Tab 3: Ejecución ── */}
    {/* ── Tab 3: Ejecución ── */}
    <div role="tabpanel" style={{ display: valueTab === 3 ? undefined : 'none', width: '100%' }}>
      <Grid container spacing={2} mt={2}>
        
        {/* ══════════════════════════════════════════
            PLAN DE ACCIÓN
        ══════════════════════════════════════════ */}
          <Grid item xs={12}>
            <SectionCard>
                <SectionHeader
                  title="PLAN DE ACCION"
                  count={planField.fields.length}
                />
                <Divider sx={{mb: 2}} />
                {planField.fields.map((field, index) => (
                <RecordCard
                  key={field.id}
                  title={`Plan #${index + 1}`}
                  disableDelete={planField.fields.length === 1}
                  onDelete={() => planField.remove(index)}
                >
                  <Grid
                    container
                    spacing={2}
                    key={field.id}
                    sx={{ mb: 2 }}
                  >
                        {/* Campos */}

                      <Grid item xs={12} md={4}>
                              <CustomAutocomplete
                                label="Acción"
                                name={`planAccion.${index}.accion`}

                                // options={ACCION_OPTIONS}
                                options={tipoaciones?.data ?? []}

                                valueKey="nombre"
                                // actualValueKey="id"
                                actualValueKey="nombre"

                                defaultValue={''}
                                isLoadingData={isLoading}
                                control={control}

                                helperText={errors.planAccion?.message}
                                error={errors.planAccion?.[index]?.accion}
                              />
                            </Grid>
                      <Grid item xs={12} md={4}>
                              <CustomAutocomplete
                                label="Responsable"
                                name={`planAccion.${index}.responsable`}
                                options={responsablesConNombre}
                                valueKey="nombre"
                                actualValueKey="responsableId"
                                control={control}
                                  
                                defaultValue={''}
                                isLoadingData = {isLoading}
                                helperText={errors.planAccion?.message ?? ''}
                                error={errors.planAccion?.[index]?.responsable}
                              />
                            </Grid>
                      <Grid item xs={12} md={4}>
                              <CustomTextField
                                label="Fecha"
                                name={`planAccion.${index}.fecha`}
                                type="date"
                                control={control}
                                shrink
                                defaultValue={''}
                                helperText={errors.planAccion?.message}
                                error={errors.planAccion?.[index]?.fecha}
                              />
                      </Grid>
                      <Grid item xs={12} md={12}>
                              <CustomTextField
                                label="Observación"
                                name={`planAccion.${index}.observacion`}
                                control={control}

                                defaultValue={''}
                                helperText={errors.planAccion?.message}
                                error={errors.planAccion?.[index]?.observacion}
                              />
                            </Grid>

            
                      </Grid>

                  </RecordCard>

                ))}

            <AddRowButton
                  label="+ Agregar Acción"
                  onClick={() => planField.append({ accion: '', responsable: '', fecha: '', observacion: '' })}
                />
            </SectionCard>
          </Grid>

        {/* ══════════════════════════════════════════
            ROLLBACK
        ══════════════════════════════════════════ */}
        <Grid item xs={12}>
          <SectionCard>
            <SectionHeader
                title="Plan de Retorno (Rollback)"
                count={rollbackField.fields.length}
              />
            <Divider sx={{mb: 2}} />

              {rollbackField.fields.map((field, index) => (
            <RecordCard
                  key={field.id}
                  title={`Rollback #${index + 1}`}
                  disableDelete={rollbackField.fields.length === 1}
                  onDelete={() => rollbackField.remove(index)}
                  >

                <Grid
                  container
                  spacing={2}
                  key={field.id}
                  sx={{ mb: 2 }}
                >
      
                  {/* Campos */}
                      <Grid item xs={12} md={12}>
                        {/* <CustomTextField
                          label="Actividad"
                          name={`rollbackActividades.${index}.actividad`}
                          control={control}
                          defaultValue={''}

                                helperText={errors.planAccion?.message}
                                error={errors.rollbackActividades?.[index]?.actividad}
                        /> */}
                        <CustomAutocomplete
                          label="Actividad"
                          name={`rollbackActividades.${index}.actividad`}
                          // options={ACCION_OPTIONS}
                          options={tipoaciones?.data ?? []}
                                // actualValueKey="id"
                          actualValueKey="nombre"
                          valueKey="nombre"
                      
                          defaultValue={''}
                          isLoadingData={isLoading}
                          control={control}
                          helperText={errors.planAccion?.message}
                          error={errors.rollbackActividades?.[index]?.actividad}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CustomTextField
                          label="Duración"
                          name={`rollbackActividades.${index}.duracion`}
                          type="time"
                          control={control}

                          defaultValue={''}
                                helperText={errors.rollbackActividades?.message}
                                error={errors.rollbackActividades?.[index]?.duracion}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CustomAutocomplete
                          label="Responsable"
                          name={`rollbackActividades.${index}.responsable`}
                          options={responsablesConNombre}
                          valueKey="nombre"
                          actualValueKey="responsableId"
                          isLoadingData = {isLoading}
                          defaultValue={''}
                          control={control}
                          error={errors.rollbackActividades?.[index]?.responsable}
                          helperText={errors.planAccion?.message ?? ''}

                        />
                      </Grid>
                </Grid>

              </RecordCard>
      
            ))}
      
            <AddRowButton
              label="+ Agregar Rollback"
              onClick={() => rollbackField.append({ actividad: '', duracion: '', responsable: '' })}
            />
          </SectionCard>
        </Grid>
      </Grid>
    </div>

  {/* ── Tab 4: Riesgos ── */}
    <div role="tabpanel" style={{ display: valueTab === 4 ? undefined : 'none', width: '100%' }}>
      <Grid container spacing={2} mt={2}>
            {/* ══════════════════════════════════════════
          ANÁLISIS DE RIESGOS
          ══════════════════════════════════════════ */}
          <Grid item xs={12}>
                <SectionCard>
                  <SectionHeader
                  title="Análisis de Riesgos"
                  count={riesgosField.fields.length}
                  />
                <Divider sx={{mb: 2}} />
                {riesgosField.fields.map((field, index) => (

                  <RecordCard 
                  key={field.id}
                  title={`Riesgo #${index + 1}`}
                  disableDelete={riesgosField.fields.length===1}
                  onDelete={()=> riesgosField.remove(index)}
                  >
                    
                  <Grid
                    container
                    spacing={2}
                    key={field.id}
                    sx={{ mb: 2 }}
                  >
            
        
                    {/* Campos */}
                      <Grid item xs={12} md={12}>
                          <CustomTextField
                            label="Descripción"
                            name={`riesgos.${index}.descripcion`}
                            control={control}

                            defaultValue={''}

                                  helperText={errors.planAccion?.message}
                                  error={errors.riesgos?.[index]?.descripcion}
                          />
                        </Grid>
                      <Grid item xs={12} md={4}>
                          <CustomAutocomplete
                            label="Impacto"
                            name={`riesgos.${index}.impacto`}
                            options={IMPACTO_OPTIONS}
                            valueKey="nombre"
                            actualValueKey="id"
                            control={control}

                            defaultValue={''}
                                  isLoadingData = {isLoading}
                                  helperText={errors.planAccion?.message}
                                  error={errors.riesgos?.[index]?.impacto}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CustomAutocomplete
                            label="Probabilidad"
                            name={`riesgos.${index}.probabilidad`}
                            options={PROBABILIDAD_OPTIONS}
                            valueKey="nombre"
                            actualValueKey="id"
                            control={control}

                            defaultValue={''}
                                  isLoadingData = {isLoading}
                                  helperText={errors.planAccion?.message}
                                  error={errors.riesgos?.[index]?.probabilidad}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CustomAutocomplete
                            label="Tipo Riesgo"
                            name={`riesgos.${index}.tipoRiesgo`}
                            options={tiposRiesgoOptions}
                            valueKey="nombre"
                            actualValueKey="id"
                            control={control}

                            defaultValue={''}
                                  isLoadingData = {isLoading}
                                  helperText={errors.planAccion?.message}
                                  error={errors.riesgos?.[index]?.tipoRiesgo}
                          />
                        </Grid>
                      <Grid item xs={12} md={12}>
                          <CustomTextField
                            label="Contingencia"
                            name={`riesgos.${index}.accionContingencia`}
                            control={control}

                            defaultValue={''}

                                  helperText={errors.planAccion?.message}
                                  error={errors.riesgos?.[index]?.accionContingencia}
                          />
                      </Grid>
                    
                </Grid>
                  </RecordCard>
              ))}
        
              <AddRowButton
                label="+ Agregar Riesgo"
                onClick={() => riesgosField.append({ descripcion: '', impacto: '', probabilidad: '', tipoRiesgo: '', accionContingencia: '' })}
              />
                </SectionCard>
          </Grid>

      </Grid>
    </div>

    {/* ── Tab 5: Aprobación ── */}
    <div role="tabpanel" style={{ display: valueTab === 5 ? undefined : 'none', width: '100%' }}>
      <Grid container spacing={2} mt={2} style={{ width: '100%!important' }}>
           <Grid item xs={12} >
            <SectionCard>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                APROBADORES
              </Typography>

            {aprobadoresField.fields.map((field, index) => {
                const row = aprobadoresRows[index] || {};
                const areaIdRow = row.areaId;

              // aprobadores ya elegidos en OTRAS filas (para no repetir)
              const yaElegidos = aprobadoresRows
                .filter((_, i) => i !== index)
                .map(r => Number(r?.aprobadorId))
                .filter(Boolean);

              // aprobadores de ESA área, quitando los ya elegidos
              const opcionesAprobador = aprobadores
                .filter(a => a.areaId === areaIdRow && !yaElegidos.includes(Number(a.usuarioId)))
                .map(a => ({ id: a.usuarioId, nombre: a.nombre }));

              return (
                <Grid container spacing={2} key={field.id} sx={{ mb: 2 }} style={{ width: '100%' }}>
                  

                  {/* Área disponible */}
                  <Grid item xs={12} md={5} sx={{ width: '100%' }}> 
                    <CustomAutocomplete
                      label="Área"
                      name={`aprobadores.${index}.areaId`}
                      // options={areas?.data || []}
                      options={areasActivas || []}
                      valueKey="nombre"
                      actualValueKey="areaId"
                      isLoadingData={isLoading}
                      control={control}
                      defaultValue=""
                      error={errors.aprobadores?.[index]?.areaId}
                      helperText={errors.aprobadores?.[index]?.areaId?.message}
                    />
                  </Grid>

                  {/* Quién puede aprobar de esa área (sin repetir) */}
                  <Grid item xs={12} md={5}>
                    <CustomAutocomplete
                      label="Aprobador"
                      name={`aprobadores.${index}.aprobadorId`}
                      options={opcionesAprobador}
                      valueKey="nombre"
                      actualValueKey="id"
                      isLoadingData={loadingAprobadores}
                      control={control}
                      defaultValue=""
                      error={errors.aprobadores?.[index]?.aprobadorId}
                      helperText={errors.aprobadores?.[index]?.aprobadorId?.message}
                    />
                  </Grid>

                  <Grid item xs={12} md={2} display="flex">
                    <Button fullWidth color="error" variant="contained"
                      disabled={aprobadoresField.fields.length === 1}
                      onClick={() => aprobadoresField.remove(index)}>
                      Eliminar
                    </Button>
                  </Grid>
                </Grid>
              );
             })}

            <AddRowButton
              label="+ Agregar aprobador"
              onClick={() => aprobadoresField.append({ areaId: '', aprobadorId: '' })}
            />
           </SectionCard>
          </Grid>
      </Grid>
    </div>

        <CreateOrCancelButtons
          onCancel={() => navigate(returnUrl)}
          onSave={handleSubmit(onSave, (errors) => {
            console.log("INVALID:", errors);
            toast.error("Revisa los campos obligatorios marcados en rojo.");
          })}
        />

      </Stack>
    </Container>
  </Box>
);



}

const AddRowButton: React.FC<{ label: string; onClick: () => void }> = ({ label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: 'none',
      border: '1px dashed #2563eb',
      color: '#2563eb',
      borderRadius: 8,
      padding: '6px 14px',
      cursor: 'pointer',
      fontSize: 13,
      marginTop: 4,
    }}
  >
    {label}
  </button>
);
